export default __webpack_public_path__ + "static/media/emailerror.22764b22.png";